var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.campaigns && _vm.campaigns.length)?_c('div',{staticClass:"ad html-ad",class:_vm.single.css_class,domProps:{"innerHTML":_vm._s(_vm.convertHTML(_vm.single.html))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }